import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { Router } from '@angular/router';
import { ContractService } from 'app/_services/contract.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html'
})

export class ContractsComponent implements OnInit {
  contactUUID: string = "";
  searchInfo: string = "";
  contractsList: any = [];
  isSearch: boolean = false;
  p: number = 0;
  limits: number = 10;
  total: number = 0;
  no_results_message: string = "";
  loading_msg = 'Chargement en cours ';
  diplay_loading = this.loading_msg;
  filter = 'all';

  searchContractForm: FormGroup = new FormGroup({
    search_contract: new FormControl("")
  })

  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService,
    private contract: ContractService
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.getContracts();

  }

  getContracts() {
    console.log('getting submission, search: ', this.isSearch);
    this.isSearch = false;
    this.diplay_loading =  this.loading_msg;
    
    this.contract.getContracts$(this.contactUUID, this.p).subscribe({
      next: (data: any) => {
        console.log('going to load all data');
        if(!this.isSearch == true) {
          console.log('loaded all data');
          this.diplay_loading = '';
          this.contractsList = data.records;
          //console.log('getting contracts', this.contractsList[0].submission_id        );
          this.total = data.count;
        }
      },
      error: (err: any) => {
        console.log("Something went wrong fetching contracts: ", err);
      }
    })
  }

  pageChangeEvent(event: number){
    this.p = event - 1;

    if (this.isSearch) {
      this.searchContract(this.searchInfo);
      console.log("Search")
    }
    else {
      this.getContracts();
      console.log("No Search")
    }
  }

  onSubmit(values: any): void {
    this.p = 0;

    this.searchInfo = values.search_contract;
    this.searchContract(this.searchInfo);
  }

  changeFilter(btnFilter:string){
    console.log("function called", btnFilter);
    this.filter = btnFilter;
    this.getContracts();
    //window.open('../myURL/mypage.jsp?rurl=' + encodeURIComponent($('display').attr('href')));
  }

  searchContract(search: string): void {
    console.log('getting search, search: ', this.isSearch);
    this.diplay_loading =  this.loading_msg;
    this.isSearch = true;
    this.contract.searchContract$(this.contactUUID, search, this.p).subscribe({
      next: (data: any) => {
        console.log('loaded search data');
        this.diplay_loading = '';
        this.contractsList = data.records;
        this.total = data.count;
        if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
        console.log(data);
      },
      error: (err: any) => {
        console.log("Something went wrong searching contracts: ", err.statusText)
      }
    });
  }

  editClient(id: number): void {
    console.log("Client id: ", id)
    this.router.navigate(['client/' + id + '/editer'])
  }

  modifyContract(id: number): void {
    console.log('contrat/' + id + '/editer')
    this.router.navigate(['contrat/' + id + '/editer'])
  }

  addOrder(submissionId: number, orderCount: number, orderId: number ): void {
    console.log("contract id: ", submissionId);
    console.log("order Count: ", orderCount);
    console.log("order Id: ", orderId);

    let orderInfo: any = {
      "submission_id": submissionId,
      "rebate": 0,
      "note": "string",
      "order_no": 0
    }
    console.log('orderInfo', orderInfo);

    if(orderCount> 0) {
      this.router.navigate(['commande/' + orderId + '/editer']);
    } else {
      this.contract.addOrderToContract(this.contactUUID, orderInfo).subscribe({
        next: (data: any) => {
          console.log('added new order', data);
          this.router.navigate(['commande/' +  data.order_id + '/editer']);
        },
        error: (err: any) => {
          console.log("Something went wrong adding order: ", err.statusText)
        }
      });
    }
  }

  addInvoice(submissionId: number, invoiceCount: number, invoiceId: number ): void {
    console.log("Invoice id: ", this.contractsList.submission_invoice );
    
    if(invoiceCount> 0) {
      this.router.navigate(['facture/' + invoiceId + '/editer']);
    } else {
      this.contract.addInvoiceToContract(this.contactUUID, submissionId).subscribe({
        next: (data: any) => {
          console.log('added new invoice', data);
          this.router.navigate(['facture/' + data.invoice_id + '/editer']);
        },
        error: (err: any) => {
          console.log("Something went wrong adding invoice: ", err)
        }
      });
    }
    
  }
}